export default __webpack_public_path__ + "static/product-analytics-2572bd13aa2f26b5201c189dd050bc3c.png";